import AdminProfilePage from "./AdminProfilePage";

export default AdminProfilePage;
